import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Loader from "react-loader-spinner";
import { Link, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { clientProfile } from "../../helpers/api";
// eslint-disable-next-line
import EthereumLogo from "../../components/Common/EthereumLogo";
import PolygonLogo from "../../components/Common/PolygonLogo";
import AvaxLogo from "../../components/Common/AvaxLogo";

class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client: {},
      loading: true,
      tokenTezos: null,
      tokenEthereum: null,
      tokenPolygon: null,
      tokenAvax: null,
      receivingBanks: null,
      ethReserve: null,
      maticReserve: null,
      avaxReserve: null,
    };
  }

  toggleCredentialsModal = () => {
    this.setState({ credentialsModal: !this.state.credentialsModal });
  };

  loadClient = async () => {
    this.setState({ loading: true });
    const res = await clientProfile();
    this.setState({
      client: res.data.client,
      tokenTezos: res.data.fa2,
      tokenEthereum: res.data.erc20,
      tokenPolygon: res.data.erc20polygon,
      tokenAvax: res.data.erc20avax,
      ethReserve: res.data.ethereum,
      maticReserve: res.data.polygon,
      avaxReserve: res.data.avax,
      receivingBanks: res.data.receivingBanks,
      loading: false,
    });
  };

  componentDidMount = () => {
    this.loadClient();
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.state.loading ? (
              <Loader type="Puff" color="#545454" height={50} width={50} />
            ) : (
              <Row>
                <Col xl="4">
                  <Card className="overflow-hidden">
                    <CardBody className="pt-2">
                      <Row>
                        {/* <Col sm="12">
                                                    <h5 className="font-size-15 text-truncate mt-4"><TezosLogo/> Tezos FA2 Contract</h5>
                                                    <p className="text-muted mb-0 text-truncate p-relative">
                                                        {this.state.tokenTezos}
                                                        <br/>
                                                        <small><Link target={"_blank"} to={{ pathname:"https://gitlab.com/sceme/salvus/eurus-tezos"}}>Git repository</Link> | <Link target={"_blank"} to={{ pathname:`https://ghostnet.tzkt.io/${this.state.tokenTezos}`}}>Block explorer</Link></small>
                                                    </p>
                                                </Col> */}

                        <Col sm="12">
                          <h5 className="font-size-15 text-truncate mt-4">
                            <EthereumLogo /> Ethereum ERC20 Contract
                          </h5>
                          <p className="text-muted mb-0 text-truncate p-relative">
                            {this.state.tokenEthereum}
                            <br />
                            <small>
                              <Link
                                target={"_blank"}
                                to={{
                                  pathname:
                                    "https://gitlab.com/sceme/salvus/eurus-solidity",
                                }}
                              >
                                Git repository
                              </Link>{" "}
                              |{" "}
                              <Link
                                target={"_blank"}
                                to={{
                                  pathname: `https://etherscan.io/address/${this.state.tokenEthereum}`,
                                }}
                              >
                                Block explorer
                              </Link>
                            </small>
                          </p>
                        </Col>

                        <Col sm="12">
                          <h5 className="font-size-15 text-truncate mt-4">
                            <PolygonLogo /> Polygon ERC20 Contract
                          </h5>
                          <p className="text-muted mb-0 text-truncate p-relative">
                            {this.state.tokenPolygon}
                            <br />
                            <small>
                              <Link
                                target={"_blank"}
                                to={{
                                  pathname:
                                    "https://gitlab.com/sceme/salvus/eurus-solidity",
                                }}
                              >
                                Git repository
                              </Link>{" "}
                              |{" "}
                              <Link
                                target={"_blank"}
                                to={{
                                  pathname: `https://polygonscan.com/address/${this.state.tokenPolygon}`,
                                }}
                              >
                                Block explorer
                              </Link>
                            </small>
                          </p>
                        </Col>

                        <Col sm="12">
                          <h5 className="font-size-15 text-truncate mt-4">
                            <AvaxLogo /> Avax ERC20 Contract
                          </h5>
                          <p className="text-muted mb-0 text-truncate p-relative">
                            {this.state.tokenAvax}
                            <br />
                            <small>
                              <Link
                                target={"_blank"}
                                to={{
                                  pathname:
                                    "https://gitlab.com/sceme/salvus/eurus-solidity",
                                }}
                              >
                                Git repository
                              </Link>{" "}
                              |{" "}
                              <Link
                                target={"_blank"}
                                to={{
                                  pathname: `https://snowtrace.io/address/${this.state.tokenAvax}`,
                                }}
                              >
                                Block explorer
                              </Link>
                            </small>
                          </p>
                        </Col>
                        <hr />
                        {this.state.receivingBanks ? (
                          <Col sm="12">
                            <h5 className="font-size-15 text-truncate mt-4">
                              SCHUMAN Financial IBAN (where to send funds)
                            </h5>
                            {Object.keys(this.state.receivingBanks).map(
                              (key) => (
                                <p
                                  key={key}
                                  className="text-muted mb-0 text-truncate p-relative"
                                >
                                  <strong>{key}</strong>:{" "}
                                  {this.state.receivingBanks[key].LU}
                                </p>
                              )
                            )}
                          </Col>
                        ) : (
                          <Col sm="12">
                            <h5 className="font-size-15 text-truncate mt-4">
                              SCHUMAN Financial IBAN (where to send funds)
                            </h5>
                            <p className="text-muted mb-0 text-truncate p-relative">
                              {this.state.client.receivingBank}
                            </p>
                          </Col>
                        )}
                        <Col sm="12">
                          <hr />
                        </Col>
                        <Col sm="12">
                          <h5 className="font-size-15 text-truncate mt-4">
                            <EthereumLogo /> Ethereum Schuman Reserve
                          </h5>
                          <p className="text-muted mb-0 p-relative">
                            {this.state.ethReserve}
                            <br />
                            <small>
                              <b>DISCLAIMER</b>
                              <br />
                              The Ethereum Schuman Reserve address is provided for informational
                              purposes only and must not be used for transfers
                              unless a formal sale request has been initiated
                            </small>
                          </p>
                        </Col>

                        <Col sm="12">
                          <h5 className="font-size-15 text-truncate mt-4">
                            <PolygonLogo /> Polygon Schuman Reserve
                          </h5>
                          <p className="text-muted mb-0 p-relative">
                            {this.state.maticReserve}
                            <br />
                            <small>
                              <b>DISCLAIMER</b>
                              <br />
                              The Polygon Schuman Reserve address is provided for informational
                              purposes only and must not be used for transfers
                              unless a formal sale request has been initiated
                            </small>
                          </p>
                        </Col>

                        <Col sm="12">
                          <h5 className="font-size-15 text-truncate mt-4">
                            <AvaxLogo /> Avax Schuman Reserve
                          </h5>
                          <p className="text-muted mb-0 p-relative">
                            {this.state.avaxReserve}
                            <br />
                            <small>
                              <b>DISCLAIMER</b>
                              <br />
                              The Avax Schuman Reserve address is provided for informational
                              purposes only and must not be used for transfers
                              unless a formal sale request has been initiated
                            </small>
                          </p>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { user } = state.Login;
  return { user };
};

export default withRouter(
  connect(mapStatetoProps, null)(withTranslation()(Info))
);
